import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import './ServicesSection.css';

const ServicesSection = ({ section, layout = 'default' }) => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      const response = await api.get('/services/', { params: { page_size: 6 } });
      setServices(response.data.results || response.data);
    } catch (error) {
      console.error('Error loading services:', error);
    }
  };

  if (services.length === 0) return null;

  const renderGridLayout = () => (
    <Row>
      {services.map(service => (
        <Col key={service.id} lg={4} md={6} sm={12} className="mb-4">
          <Card className="service-card h-100 text-center service-card-grid">
            <Card.Body>
              {service.icon && (
                <div className="service-icon">
                  <i className={service.icon}></i>
                </div>
              )}
              <Card.Title>
                <Link to={`/services/${service.slug}`}>{service.name}</Link>
              </Card.Title>
              <Card.Text className="small">
                {service.description.replace(/<[^>]*>/g, '').substring(0, 100)}...
              </Card.Text>
              <Link to={`/services/${service.slug}`} className="btn btn-outline-primary btn-sm">
                Learn More
              </Link>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );

  const renderListLayout = () => (
    <div className="services-list">
      {services.map(service => (
        <div key={service.id} className="service-list-item border-bottom py-4">
          <Row className="align-items-center">
            <Col lg={2} md={3} xs={3} className="text-center">
              {service.icon && (
                <div className="service-icon-large">
                  <i className={service.icon}></i>
                </div>
              )}
            </Col>
            <Col lg={10} md={9} xs={9}>
              <h5>
                <Link to={`/services/${service.slug}`}>{service.name}</Link>
              </h5>
              <p className="mb-0 text-muted">
                {service.description.replace(/<[^>]*>/g, '').substring(0, 150)}...
              </p>
              <Link to={`/services/${service.slug}`} className="btn btn-sm btn-link mt-2">
                Learn More <i className="fas fa-arrow-right ms-1"></i>
              </Link>
            </Col>
          </Row>
        </div>
      ))}
    </div>
  );

  const renderCompactLayout = () => (
    <Row className="g-2">
      {services.map(service => (
        <Col key={service.id} lg={3} md={4} sm={6} xs={6} className="mb-3">
          <Card className="service-card-compact text-center h-100">
            <Card.Body className="p-3">
              {service.icon && (
                <div className="service-icon-compact">
                  <i className={service.icon}></i>
                </div>
              )}
              <h6 className="mt-3 mb-2">
                <Link to={`/services/${service.slug}`}>{service.name}</Link>
              </h6>
              <Link to={`/services/${service.slug}`} className="btn btn-sm btn-outline-primary w-100">
                View
              </Link>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );

  const renderContent = () => {
    switch(layout) {
      case 'list':
        return renderListLayout();
      case 'compact':
        return renderCompactLayout();
      case 'grid':
      case 'default':
      default:
        return renderGridLayout();
    }
  };

  return (
    <section className={`services-section homepage-section services-layout-${layout}`}>
      <Container>
        <h2 className="section-title">{section.title}</h2>
        {renderContent()}
        <div className="text-center mt-4">
          <Link to="/services" className="btn btn-primary">View All Services</Link>
        </div>
      </Container>
    </section>
  );
};

export default ServicesSection;
